var map = {
	"./123chat.jpg": "./src/assets/plugins/123chat.jpg",
	"./ccm19.jpg": "./src/assets/plugins/ccm19.jpg",
	"./chatGPT.jpg": "./src/assets/plugins/chatGPT.jpg",
	"./cookie_consent.jpg": "./src/assets/plugins/cookie_consent.jpg",
	"./cookiebot.jpg": "./src/assets/plugins/cookiebot.jpg",
	"./disqus.jpg": "./src/assets/plugins/disqus.jpg",
	"./embed.jpg": "./src/assets/plugins/embed.jpg",
	"./exit_intent.jpg": "./src/assets/plugins/exit_intent.jpg",
	"./facebook_tag.jpg": "./src/assets/plugins/facebook_tag.jpg",
	"./feedbucket.jpg": "./src/assets/plugins/feedbucket.jpg",
	"./floating_icon.jpg": "./src/assets/plugins/floating_icon.jpg",
	"./gated_content.jpg": "./src/assets/plugins/gated_content.jpg",
	"./google_analytics.jpg": "./src/assets/plugins/google_analytics.jpg",
	"./google_tag.jpg": "./src/assets/plugins/google_tag.jpg",
	"./intro.jpg": "./src/assets/plugins/intro.jpg",
	"./lead-modal.jpg": "./src/assets/plugins/lead-modal.jpg",
	"./linkedin_tag.jpg": "./src/assets/plugins/linkedin_tag.jpg",
	"./matomo_analytics.jpg": "./src/assets/plugins/matomo_analytics.jpg",
	"./password.jpg": "./src/assets/plugins/password.jpg",
	"./plausible.jpg": "./src/assets/plugins/plausible.jpg",
	"./plugin-placeholder.png": "./src/assets/plugins/plugin-placeholder.png",
	"./usercentrics.jpg": "./src/assets/plugins/usercentrics.jpg",
	"./variables.jpg": "./src/assets/plugins/variables.jpg",
	"./webmag_analytics.jpg": "./src/assets/plugins/webmag_analytics.jpg",
	"./weglot.jpg": "./src/assets/plugins/weglot.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/plugins sync recursive ^\\.\\/.*$";